module.exports = __webpack_public_path__ + "static/img/last_page.70ef1902.svg";